/* [PATCH nastavitve-zavihki v1] preseljeno 1:1 iz ProfilPage.tsx:
   smer='prejeti' -> tabela polj 474-542, smer='izdani' -> 544-605.
   Komponenta DdvKontiZavihka (615-632) se NE prenese — zavihka ni vec,
   smer dolocajo zavihki strani Nastavitve. Kljuci ddv_konti nespremenjeni. */
import React from 'react';
import { Percent } from 'lucide-react';
import { KontoInput } from '../KontoInput';

export function DdvKontiKartica({ smer, data, set }: {
  smer: 'prejeti' | 'izdani';
  data: any;
  set: (field: string, value: any) => void;
}) {
  const naslov = smer === 'prejeti' ? 'DDV konti — prejeti računi' : 'DDV konti — izdani računi';
  /* placeholder je privzeti konto polja (sivi namig) — pride iz tabele polj
     spodaj, tocno kot v originalu (ProfilPage 474-605). Nikoli trdo prazen. */
  const vpis = (field: string, placeholder: string) => (
    <KontoInput
      value={(data?.ddv_konti || {})[field] || ''}
      onChange={(konto) => set('ddv_konti', { ...(data?.ddv_konti || {}), [field]: konto })}
      placeholder={placeholder}
    />
  );

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-blue-50 dark:bg-blue-900/30 text-blue-600 flex items-center justify-center">
          <Percent className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">{naslov}</h2>
          <p className="text-xs text-gray-500">Konti za knjiženje DDV po stopnjah in vrstah</p>
        </div>
      </div>

      <div className="mt-4">
      {smer === 'prejeti' ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-6 gap-4">
          {[
            // PATCH_DDV_MATRIKA_FE_V1: matrika kategorija x stopnja x stran (Vasco slog)
            { field: '__section__dom', label: 'Domače pridobitve in pavšal — vstopni', placeholder: '' },
            { field: 'konto_ddv_22', label: 'Vstopni DDV 22%', placeholder: '160000' },
            { field: 'konto_ddv_95', label: 'Vstopni DDV 9,5%', placeholder: '160000' },
            { field: 'konto_ddv_5', label: 'Vstopni DDV 5%', placeholder: '160000' },
            { field: 'konto_ddv_pavsal_vstopni_8', label: 'Pavšalno nadomestilo 8%', placeholder: '160000' },
            /* [PATCH izdani-ddv-konti v2] polja obracunanega DDV izdanih preseljena v zavihek "Izdani racuni" */
            { field: '__section__so', label: 'Samoobdavčitev — prejemnik blaga in storitev', placeholder: '' },
            { field: 'konto_ddv_so_vstopni_22', label: 'Vstopni 22%', placeholder: '160000' },
            { field: 'konto_ddv_so_obracunani_22', label: 'Obračunani 22%', placeholder: '260000' },
            { field: 'konto_ddv_so_vstopni_95', label: 'Vstopni 9,5%', placeholder: '160000' },
            { field: 'konto_ddv_so_obracunani_95', label: 'Obračunani 9,5%', placeholder: '260000' },
            { field: 'konto_ddv_so_vstopni_5', label: 'Vstopni 5%', placeholder: '160000' },
            { field: 'konto_ddv_so_obracunani_5', label: 'Obračunani 5%', placeholder: '260000' },
            { field: '__section__76a', label: 'Samoobdavčitev — 76.a člen', placeholder: '' },
            { field: 'konto_ddv_76a_vstopni_22', label: 'Vstopni 22%', placeholder: '160000' },
            { field: 'konto_ddv_76a_obracunani_22', label: 'Obračunani 22%', placeholder: '260000' },
            { field: 'konto_ddv_76a_vstopni_95', label: 'Vstopni 9,5%', placeholder: '160000' },
            { field: 'konto_ddv_76a_obracunani_95', label: 'Obračunani 9,5%', placeholder: '260000' },
            { field: '__section__eub', label: 'Pridobitve blaga v EU', placeholder: '' },
            { field: 'konto_ddv_eu_blago_vstopni_22', label: 'Vstopni 22%', placeholder: '160000' },
            { field: 'konto_ddv_eu_blago_obracunani_22', label: 'Obračunani 22%', placeholder: '260000' },
            { field: 'konto_ddv_eu_blago_vstopni_95', label: 'Vstopni 9,5%', placeholder: '160000' },
            { field: 'konto_ddv_eu_blago_obracunani_95', label: 'Obračunani 9,5%', placeholder: '260000' },
            { field: 'konto_ddv_eu_blago_vstopni_5', label: 'Vstopni 5%', placeholder: '160000' },
            { field: 'konto_ddv_eu_blago_obracunani_5', label: 'Obračunani 5%', placeholder: '260000' },
            { field: '__section__eus', label: 'Pridobitve storitev v EU', placeholder: '' },
            { field: 'konto_ddv_eu_stor_vstopni_22', label: 'Vstopni 22%', placeholder: '160000' },
            { field: 'konto_ddv_eu_stor_obracunani_22', label: 'Obračunani 22%', placeholder: '260000' },
            { field: 'konto_ddv_eu_stor_vstopni_95', label: 'Vstopni 9,5%', placeholder: '160000' },
            { field: 'konto_ddv_eu_stor_obracunani_95', label: 'Obračunani 9,5%', placeholder: '260000' },
            { field: 'konto_ddv_eu_stor_vstopni_5', label: 'Vstopni 5%', placeholder: '160000' },
            { field: 'konto_ddv_eu_stor_obracunani_5', label: 'Obračunani 5%', placeholder: '260000' },
            { field: '__section__uvoz', label: 'Uvoz — vstopni', placeholder: '' },
            { field: 'konto_ddv_uvoz_vstopni_22', label: 'Vstopni 22%', placeholder: '160000' },
            { field: 'konto_ddv_uvoz_vstopni_95', label: 'Vstopni 9,5%', placeholder: '160000' },
            { field: 'konto_ddv_uvoz_vstopni_5', label: 'Vstopni 5%', placeholder: '160000' },
            { field: '__spacer__uvoz', label: '', placeholder: '' },
            { field: '__section__souvoz', label: 'Samoobdavčitev uvoza', placeholder: '' },
            { field: 'konto_ddv_so_uvoz_vstopni_22', label: 'Vstopni 22%', placeholder: '160000' },
            { field: 'konto_ddv_so_uvoz_obracunani_22', label: 'Obračunani 22%', placeholder: '260000' },
            { field: 'konto_ddv_so_uvoz_vstopni_95', label: 'Vstopni 9,5%', placeholder: '160000' },
            { field: 'konto_ddv_so_uvoz_obracunani_95', label: 'Obračunani 9,5%', placeholder: '260000' },
            { field: 'konto_ddv_so_uvoz_vstopni_5', label: 'Vstopni 5%', placeholder: '160000' },
            { field: 'konto_ddv_so_uvoz_obracunani_5', label: 'Obračunani 5%', placeholder: '260000' },
            /* PATCH_DDV_IZDANE_VEN_GEN_V1: izdane fakture odstranjene iz forme */
            { field: '__section__gen', label: 'Generična konta (fallback, če zgoraj ni vpisa)', placeholder: '' },
            { field: 'konto_ddv_genericni_vstopni', label: 'Generični vstopni (16)', placeholder: '160000' },
            { field: 'konto_ddv_genericni_obracunani', label: 'Generični obračunani (26)', placeholder: '260000' },
            { field: '__section__avans', label: 'Avansi', placeholder: '' },
            { field: 'konto_dani_avansi_ddv', label: 'Dani avansi DDV', placeholder: '295000' },
            { field: 'konto_kratkorocni_dani_predujmi', label: 'Kratkoročni dani predujmi', placeholder: '133000' },
          ].map(({ field, label, placeholder }) => (
            field.startsWith('__section__') ? (
              <div key={field} className="sm:col-span-full mt-2 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-800 border-l-4 border-l-blue-500 text-xs font-bold uppercase tracking-wider text-gray-700 dark:text-gray-200">{label}</div>
            ) : field.startsWith('__spacer__') ? <div key={field} className="hidden sm:block" /> : (
            <div key={field}>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{label}</label>
              {vpis(field, placeholder)}
            </div>
            )
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-6 gap-4">
          <div className="sm:col-span-full mt-2 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-800 border-l-4 border-l-blue-500 text-xs font-bold uppercase tracking-wider text-gray-700 dark:text-gray-200">DDV na domačem trgu</div>
          {[
            { field: 'konto_ddv_dom_obracunani_22', label: 'Obračunani DDV 22%', placeholder: '260000' },
            { field: 'konto_ddv_dom_obracunani_95', label: 'Obračunani DDV 9,5%', placeholder: '260000' },
            { field: 'konto_ddv_dom_obracunani_5', label: 'Obračunani DDV 5%', placeholder: '260000' },
          ].map(({ field, label, placeholder }) => (
            <div key={field}>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{label}</label>
              {vpis(field, placeholder)}
            </div>
          ))}
          {/* [PATCH ir4a-ui-profil v1] privzeti konto prihodkov -- fallback za razbitje izdanih */}
          <div className="sm:col-span-full mt-2 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-800 border-l-4 border-l-blue-500 text-xs font-bold uppercase tracking-wider text-gray-700 dark:text-gray-200">Prihodki</div>
          <div className="sm:col-span-2">
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Privzeti konto prihodkov (fallback)</label>
            {vpis('konto_prihodki_privzeti', '7600')}
            <p className="text-[11px] text-gray-500 mt-1">Ko za postavko ni pravila in za kupca ni učnega vzorca.</p>
          </div>
          {/* [PATCH izdani-terjatve-profil v1] konta terjatev do kupcev.
              Fallback, kadar za kupca NI ucnega vzorca -- vzorec ima prednost. */}
          <div className="sm:col-span-full mt-2 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-800 border-l-4 border-l-blue-500 text-xs font-bold uppercase tracking-wider text-gray-700 dark:text-gray-200">Terjatve do kupcev</div>
          {[
            { field: 'konto_terjatve_dom', label: 'Terjatve — domači kupci', placeholder: '120000' },
            { field: 'konto_terjatve_tujina', label: 'Terjatve — tujina (EU / izvoz)', placeholder: '121000' },
          ].map(({ field, label, placeholder }) => (
            <div key={field}>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{label}</label>
              {vpis(field, placeholder)}
            </div>
          ))}
          <div className="sm:col-span-full -mt-1">
            <p className="text-[11px] text-gray-500">Uporabi se samo, ko za kupca ni učnega vzorca. Brez vpisa velja 1200 / 1210.</p>
          </div>
          {/* [PATCH izdani-avans-profil v1] konta za IZDANE avanse (predujmi od kupcev) */}
          <div className="sm:col-span-full mt-2 px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-800 border-l-4 border-l-blue-500 text-xs font-bold uppercase tracking-wider text-gray-700 dark:text-gray-200">Avansi (prejeti predujmi od kupcev)</div>
          {[
            { field: 'konto_prejeti_avansi_ddv', label: 'Prejeti avansi DDV', placeholder: '195000' },
            { field: 'konto_kratkorocni_prejeti_predujmi', label: 'Kratkoročni prejeti predujmi', placeholder: '230000' },
          ].map(({ field, label, placeholder }) => (
            <div key={field}>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{label}</label>
              {vpis(field, placeholder)}
            </div>
          ))}
        </div>
      )}
      </div>
    </div>
  );
}
